export const home = {
  hero: {
    title: 'Powering Global Energy',
    titleHighlight: 'Infrastructure',
    description: 'Leading supplier and distributor of natural gas and electricity, delivering reliable energy solutions across international markets with uncompromising safety and efficiency standards.',
    cta: 'Explore Solutions',
    countriesServed: 'Countries Served',
    energyCapacity: 'Energy Capacity',
    reliabilityRate: 'Reliability Rate'
  },
  services: {
    title: 'Comprehensive Energy Solutions',
    subtitle: 'From upstream sourcing to final delivery, we provide integrated energy services that meet the most demanding industrial and commercial requirements.',
    naturalGas: {
      title: 'Natural Gas Supply',
      description: 'Comprehensive upstream sourcing, hedging strategies, contract management, and reliable delivery to strategic points across global markets.',
      features: ['Upstream Sourcing', 'Risk Hedging', 'Contract Management', 'Delivery Networks']
    },
    electricity: {
      title: 'Electricity Supply',
      description: 'Power purchase agreements, grid balancing services, access management, and advanced metering solutions for industrial and commercial clients.',
      features: ['PPA Structures', 'Grid Balancing', 'Access Management', 'Smart Metering']
    },
    infrastructure: {
      title: 'Infrastructure Solutions',
      description: 'End-to-end pipeline systems, metering stations, SCADA implementation, and comprehensive maintenance programs for energy infrastructure.',
      features: ['Pipeline Systems', 'Metering Stations', 'SCADA Systems', 'Maintenance Programs']
    },
    compliance: {
      title: 'Risk & Compliance',
      description: 'Regulatory reporting, emissions monitoring, safety standards implementation, and comprehensive compliance management across all operations.',
      features: ['Regulatory Reporting', 'Emissions Monitoring', 'Safety Standards', 'Compliance Management']
    },
    learnMore: 'Learn More'
  },
  stats: {
    title: 'Trusted by Industry Leaders',
    subtitle: 'Our commitment to excellence is reflected in our operational metrics and the trust placed in us by global energy partners.',
    countriesServed: 'Countries Served',
    countriesServedDesc: 'Global presence across major energy markets',
    energyCapacity: 'Energy Capacity',
    energyCapacityDesc: 'Combined natural gas and electricity capacity',
    reliabilityRate: 'Reliability Rate',
    reliabilityRateDesc: 'Consistent uptime across all operations',
    enterpriseClients: 'Enterprise Clients',
    enterpriseClientsDesc: 'Trusted by leading industrial companies',
    yearsExperience: 'Years Experience',
    yearsExperienceDesc: 'Proven track record in energy markets',
    operationsCenter: 'Operations Center',
    operationsCenterDesc: 'Continuous monitoring and support',
    certifiedCompliant: 'Certified & Compliant'
  },
  cta: {
    title: 'Ready to Power Your Operations?',
    subtitle: 'Connect with our energy specialists to discuss your requirements and discover how we can optimize your energy infrastructure.',
    consultation: 'Schedule Consultation',
    brochure: 'Download Brochure',
    callSales: 'Call Sales',
    emailUs: 'Email Us',
    address: 'Address'
  }
};
